import moment from "moment";
import { useEffect, useState } from "react";
import { API_URL, REACT_APP_SITE_KEY } from "../../config/app-config";
import calendar from "../../img/calendar.png";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import { FiArrowRight, FiDownload, FiLock, FiCalendar, FiClock, FiZap } from "react-icons/fi";
import { FaStar } from "react-icons/fa";

import "./ServiceCardThemeV14.css";

moment.locale("en");

// Calendar Component
function MonthGridCalendar({ slots, packageDays, selectedValue, onSelect }) {
  const today = moment().locale("en");
  const [viewMonth, setViewMonth] = useState(today.clone().startOf("month"));

  const availableSet = new Set((slots || []).filter((s) => s.available).map((s) => s.value));
  const slotMap = {};
  (slots || []).forEach((s) => { slotMap[s.value] = s; });

  const goMonth = (dir) => setViewMonth((prev) => prev.clone().locale("en").add(dir, "month").startOf("month"));

  const vmEn = viewMonth.clone().locale("en");
  const startDay = vmEn.clone().startOf("month").day();
  const daysInMonth = vmEn.daysInMonth();

  const cells = [];
  for (let i = 0; i < startDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);

  const weeks = [];
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));

  const DOW = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  const isPrevDisabled = viewMonth.clone().locale("en").isSameOrBefore(today.clone().startOf("month"));

  return (
    <div>
      <div className="monthNavRow" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <button type="button" onClick={() => goMonth(-1)} disabled={isPrevDisabled} style={{ background: 'none', border: 'none', cursor: isPrevDisabled ? 'not-allowed' : 'pointer', fontSize: '18px', color: 'var(--v14-muted)' }}>‹</button>
        <h4 style={{ margin: 0, fontSize: '14px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--v14-green)' }}>{vmEn.format("MMMM YYYY")}</h4>
        <button type="button" onClick={() => goMonth(1)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', color: 'var(--v14-muted)' }}>›</button>
      </div>
      <table className="monthGridCalendar" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
        <thead>
          <tr>{DOW.map((d) => (<th key={d} style={{ padding: '8px 0', fontSize: '12px', opacity: 0.7 }}>{d}</th>))}</tr>
        </thead>
        <tbody>
          {weeks.map((week, wi) => (
            <tr key={wi}>
              {week.map((day, di) => {
                if (!day) return <td key={di}><div style={{ padding: '8px' }}></div></td>;
                const dateVal = vmEn.clone().date(day).format("YYYY/MM/DD");
                const isPast = vmEn.clone().date(day).isBefore(today, "day");
                const dayMatches = packageDays.length === 0 || packageDays.includes(moment(dateVal, "YYYY/MM/DD").locale("en").format("ddd").toUpperCase());
                const isAvail = availableSet.has(dateVal) && !isPast && dayMatches;
                const isSelected = selectedValue === dateVal;

                let btnClass = "gridDayBtn ";
                if (isSelected) btnClass += "gridSelected";
                else if (isAvail) btnClass += "gridAvailable";

                return (
                  <td key={di} style={{ padding: '4px' }}>
                    <button
                      type="button"
                      className={btnClass}
                      style={{ width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto', cursor: isAvail ? 'pointer' : 'not-allowed', opacity: isAvail || isSelected ? 1 : 0.3 }}
                      onClick={(e) => {
                        e.preventDefault();
                        if (!isAvail) return;
                        const slotObj = slotMap[dateVal];
                        if (slotObj) onSelect(slotObj);
                      }}
                    >
                      {day}
                    </button>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// Time Panel Component
function TimeSidePanel({ hasDateSelected, slots, selectedSlot, onSelect, isDisabledFn }) {
  return (
    <div className="timeSide">
      <div className="v14-section-eyebrow" style={{ marginBottom: '16px' }}>
        <FiClock size={14} style={{ marginRight: '6px', verticalAlign: 'text-bottom' }} />
        Select Time
      </div>
      {!hasDateSelected ? (
        <div style={{ opacity: 0.5, fontSize: '13px', fontWeight: 600 }}>Pick a date to see times</div>
      ) : (
        <div className="v14-twoColSlots">
          {slots.length > 0 ? (
            slots.map((item, i) => {
              const fromStr = item.from ?? "";
              const toStr = item.to ?? "";
              const fmt = fromStr.includes("AM") || fromStr.includes("PM") ? "hh:mm A" : "HH:mm";
              const displayFrom = moment(fromStr, fmt).isValid() ? moment(fromStr, fmt).format("h:mm A") : fromStr;
              const displayTo = moment(toStr, fmt).isValid() ? moment(toStr, fmt).format("h:mm A") : toStr;
              const isSelected = selectedSlot?.from === fromStr && selectedSlot?.to === toStr;
              const isDisabled = isDisabledFn ? isDisabledFn(item) : false;

              return (
                <button
                  type="button"
                  key={i}
                  className={`timeSlotBtn ${isSelected ? 'tsActive' : ''}`}
                  style={{ padding: '12px', fontSize: '13px', cursor: isDisabled ? 'not-allowed' : 'pointer', opacity: isDisabled ? 0.5 : 1 }}
                  onClick={(e) => { e.preventDefault(); if (!isDisabled) onSelect(item); }}
                >
                  {displayFrom} – {displayTo}
                </button>
              );
            })
          ) : (
            <p style={{ gridColumn: '1/-1', fontSize: '13px', opacity: 0.7, fontWeight: 600 }}>No slots available</p>
          )}
        </div>
      )}
    </div>
  );
}

// Main Component
const ServiceCardThemeV14 = ({
  data,
  selectService,
  isPreview,
  uploadDetails,
  updateState,
  confirmDetails,
  recaptcha,
  viewAvailableSlot,
  slugSelected,
  onResourceClick,
}) => {

  const eventData = data.eventData || data.eventDetails || {};
  const userDetails = data.userDetails || {};
  const resourceList = data.resource || data.resourceList || [];

  const businessLogo = isPreview
    ? eventData.businessLogo
    : eventData.businessLogo ? `${API_URL}auth/image/${eventData.businessLogo}` : calendar;

  const businessName = eventData.businessName || userDetails.userName || "Ritu Narang";

  // NEW UI: hero title now prefers sliderTextOne, falling back to serviceName then the default
  const displayTitle = eventData.sliderTextOne || eventData.serviceName || "Language grows when you use it.";
  // NEW UI: hero eyebrow now prefers sliderTextTwo (was sliderTextOne, which now feeds the title above)
  const displayEyebrow = eventData.sliderTextTwo || eventData.sliderTextOne || "SPEAK MORE, SOONER";

  const rawReviews = data.reviewList || [];
  const dummyReviews = [
    { name: "Aditi G.", source: "Google", suggestion: "I stopped translating in my head by week three.", satisfaction: 5, updateDate: Date.now() },
    { name: "Meera S.", source: "Parent review", suggestion: "My son now explains his working instead of avoiding the question.", satisfaction: 5, updateDate: Date.now() - 86400000 },
    { name: "Vikram R.", source: "Google", suggestion: "A thoughtful tutor who makes difficult ideas feel possible.", satisfaction: 5, updateDate: Date.now() - 172800000 }
  ];
  const reviews = rawReviews.length > 0 ? rawReviews : dummyReviews;
  const avgRating = eventData.ratings ?? "4.9/5";

  const dummyServices = [
    { serviceName: "Hola, ¿qué tal?", duration: 60, amount: 1000, appointmentName: "INDIVIDUAL LESSON", description: "Spanish starter circle — one-to-one teaching paced around the learner and the topic." },
    { serviceName: "On se parle?", duration: 60, amount: 1100, appointmentName: "SMALL GROUP CLASS", description: "French conversation — a small, conversational class with plenty of speaking time." },
    { serviceName: "Travel ready", duration: 75, amount: 1650, appointmentName: "INDIVIDUAL LESSON", description: "Private lesson — a focused tutorial with worked examples and clear feedback." },
    { serviceName: "Club hour", duration: 60, amount: 750, appointmentName: "GROUP CLASS", description: "Small group — a shared session for learning with momentum and accountability." }
  ];
  const rawServiceList = data.service || data.serviceList || [];
  const serviceList = rawServiceList.length > 0 ? rawServiceList : dummyServices;

  const [chosenService, setChosenService] = useState(null);
  const [isPackageSelected, setIsPackageSelected] = useState({});
  const [reviewIndex, setReviewIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedNoteOption, setSelectedNoteOption] = useState(""); // Track the dropdown selection
  const isMobile = window.screen.width < 768;

  useEffect(() => {
    if (!slugSelected || !serviceList.length) return;
    const index = serviceList.findIndex((s) => s.slug === slugSelected || String(s.id) === String(slugSelected));
    if (index !== -1) handleBookClick(serviceList[index], index);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slugSelected, serviceList]);

  // FIX 2: close the modal automatically once a booking completes.
  // The free-booking flow never toggled isModalOpen (it's local state here),
  // so the modal stayed open after a free booking succeeded. The parent
  // (CalendarVcard) flips data.bookingSuccess to true on both the free and
  // paid success paths — this effect reacts to that signal.
  useEffect(() => {
    if (data.bookingSuccess) {
      setIsModalOpen(false);
    }
  }, [data.bookingSuccess]);

  const safeParse = (value) => {
    try {
      if (!value) return [];
      const p = JSON.parse(value);
      return typeof p === "string" ? JSON.parse(p) : p;
    } catch (e) { return []; }
  };

  const packageDays = safeParse(isPackageSelected?.packageDays);
  const timeSlots = safeParse(isPackageSelected?.timeSlots) || [];

  const getAllSlots = () => {
    if (!data.availableSlot?.length) return [];
    return data.availableSlot.filter((item) => {
      if (Object.keys(data?.activeIndexData || {}).length > 0) {
        const isToday = moment(data.activeIndexData.value, "YYYY/MM/DD");
        if (isToday.isSame(moment(), "day")) {
          const curTime = moment(new Date(), "HH:mm");
          const fromTime = moment(item.from, "HH:mm");
          return fromTime.isSameOrAfter(curTime);
        }
      }
      return true;
    });
  };

  const priceLabel = (svc) => (svc?.amount == 0 ? "Free" : `₹${svc?.amount}`);
  const selectedServiceObj = chosenService !== null ? serviceList[chosenService] : null;

  const handleBookClick = (item, ind) => {
    selectService(item);
    setChosenService(ind);
    setIsPackageSelected(item);
    updateState("bookingMode", "self");
    updateState("expertNote", "");
    updateState("bookingSuccess", false); // FIX 2: clear any stale success flag from a previous booking
    setIsModalOpen(true);
  };

  const handleResourceCardClick = (res) => {
    if (isPreview) return;
    if (typeof onResourceClick === "function") onResourceClick(res);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    updateState("name", "");
    updateState("email", "");
    updateState("phoneNumber", "");
    updateState("description", "");
    updateState("detailsPage", false); // Reset back to step 1
    updateState("bookingSuccess", false); // FIX 2: keep state clean on manual close too
    setSelectedNoteOption(""); // Reset dropdown selection

    if (recaptcha?.current) {
      recaptcha.current.reset();
    }
  };

  const handleNextReview = () => setReviewIndex((prev) => (prev + 1) % reviews.length);
  const handlePrevReview = () => setReviewIndex((prev) => (prev - 1 + reviews.length) % reviews.length);

  // Stepper Component
  const renderStepper = (activeStep) => (
    <div className="v14-bkStepBar">
      <div className={`v14-bkStep ${activeStep === 1 ? "active" : activeStep > 1 ? "done" : ""}`}>
        <div className="v14-bkStepCircle">{activeStep > 1 ? "✓" : "1"}</div>
        <span>Choose option</span>
      </div>
      <div className={`v14-bkStepLine ${activeStep > 1 ? "done" : ""}`} />
      <div className={`v14-bkStep ${activeStep === 2 ? "active" : activeStep > 2 ? "done" : ""}`}>
        <div className="v14-bkStepCircle">{activeStep > 2 ? "✓" : "2"}</div>
        <span>Provide details</span>
      </div>
      <div className={`v14-bkStepLine ${activeStep > 2 ? "done" : ""}`} />
      <div className={`v14-bkStep ${activeStep === 3 ? "active" : ""}`}>
        <div className="v14-bkStepCircle">3</div>
        <span>Confirmation</span>
      </div>
    </div>
  );

  // Modal Booking Flow
  const renderBookingModal = () => {
    if (!isModalOpen || chosenService === null) return null;
    const isGroupPackage = ["group_package", "one_to_one_package"].includes(isPackageSelected?.appointmentName);

    return (
      <div className="v14-modal-overlay" onClick={closeModal}>
        <div className="v14-modal-content" onClick={(e) => e.stopPropagation()}>
          <button type="button" className="v14-modal-close" onClick={closeModal}>×</button>

          {data.detailsPage ? (
            <form onSubmit={(e) => { e.preventDefault(); uploadDetails(e); }} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {renderStepper(2)}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px' }}>
                <h4 style={{ margin: 0, fontSize: '24px', fontFamily: 'var(--font-serif)', color: 'var(--v14-green)' }}>Provide Details</h4>
                <button type="button" onClick={() => { recaptcha?.current?.reset(); updateState("detailsPage", false); }} className="v14-btn-outline" style={{ border: 'none' }}>
                  ← Back to options
                </button>
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', fontWeight: 700, textTransform: 'uppercase', color: 'var(--v14-muted)' }}>Name *</label>
                <input className="input-text-input" value={data.name} type="text" placeholder="ENTER NAME" required onChange={(e) => updateState("name", e.target.value)} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', fontWeight: 700, textTransform: 'uppercase', color: 'var(--v14-muted)' }}>Email *</label>
                <input className="input-text-input" value={data.email} type="email" placeholder="ENTER EMAIL" required onChange={(e) => updateState("email", e.target.value?.trim())} />
              </div>
                <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:600 }}>Phone Number *</label>
                <div style={{ marginTop: "4px" }}>
                  <PhoneInput
                    country={"in"}
                    containerClass="input-dark"
                    value={data.phoneNumber}
                    placeholder=""
                    countryCodeEditable={false}
                    onChange={(phone) => updateState("phoneNumber", phone)}
                    required
                  />
                </div>
              </div>
                  <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:600 }}>Notes for preparation *</label>
                <select 
                  className="input-text-input" 
                  value={selectedNoteOption}
                  required
                  onChange={(e) => {
                    setSelectedNoteOption(e.target.value);
                    if (e.target.value !== "Other") {
                      updateState("description", e.target.value);
                    } else {
                      updateState("description", "");
                    }
                  }}
                  style={{ marginBottom: selectedNoteOption === "Other" ? '12px' : '0' }}
                >
                  <option value="" disabled>Select an option</option>
                  <option value="I'm looking for general relaxation and mindfulness.">I'm looking for general relaxation and mindfulness.</option>
                  <option value="I'm dealing with specific tension/tightness and need relief.">I'm dealing with specific tension/tightness and need relief.</option>
                  <option value="I'm a beginner looking for a gentle introduction.">I'm a beginner looking for a gentle introduction.</option>
                  <option value="Other">Other (I will type my own notes)</option>
                </select>

                {selectedNoteOption === "Other" && (
                  <textarea 
                    className="input-text-input" 
                    value={data.description} 
                    required={selectedNoteOption === "Other"} 
                    placeholder="Please specify your requirements or notes here..."
                    onChange={(e) => updateState("description", e.target.value)} 
                    style={{ minHeight: '100px', resize: 'vertical' }} 
                  />
                )}
              </div>

              <div style={{ margin: "8px 0" }}>
                <ReCAPTCHA size={isMobile ? "compact" : "normal"} ref={recaptcha} sitekey={REACT_APP_SITE_KEY} />
              </div>

              <button type="submit" className="v14-btn-primary" onClick={() => confirmDetails()} style={{ alignSelf: 'flex-start' }}>
                <FiCalendar size={16} /> Book {selectedServiceObj?.serviceName} - {priceLabel(selectedServiceObj)} <FiArrowRight size={16} />
              </button>
            </form>
          ) : (
            <div>
              {renderStepper(1)}

              {!isGroupPackage && (
                <>
                  <div style={{ marginBottom: '32px', textAlign: 'center' }}>
                    <h2 style={{ fontSize: '32px', fontFamily: 'var(--font-serif)', color: 'var(--v14-green)', marginBottom: '8px' }}>
                      Schedule your session
                    </h2>
                    <p style={{ opacity: 0.7, fontWeight: 500, fontSize: '13px' }}>
                      Choose how you&apos;d like to book
                    </p>
                  </div>

                  <div className="v14-bkModeRow">
                    <div className={`v14-bkModeCard ${data.bookingMode === "self" ? "bkSelected" : ""}`} onClick={() => updateState("bookingMode", "self")}>
                      <div className="v14-bkModeRadio">{data.bookingMode === "self" && <div className="v14-bkModeRadioInner" />}</div>
                      <div className="v14-bkModeText">
                        <h5>I&apos;ll pick date & time</h5>
                        <p>Select from available slots</p>
                      </div>
                    </div>

                    <div className={`v14-bkModeCard ${data.bookingMode === "expert" ? "bkSelected" : ""}`} onClick={() => updateState("bookingMode", "expert")}>
                      <div className="v14-bkModeRadio">{data.bookingMode === "expert" && <div className="v14-bkModeRadioInner" />}</div>
                      <div className="v14-bkModeText">
                        <h5>Let the expert choose</h5>
                        <p>Share your preference and expert will schedule</p>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {data.bookingMode === "expert" && !isGroupPackage && (
                <div style={{ padding: '32px', background: '#fff', border: '1px solid var(--v14-border)', marginBottom: '32px', borderRadius: '4px' }}>
                  <label style={{ display: 'block', marginBottom: '16px', fontSize: '14px', fontWeight: 700, color: 'var(--v14-green)' }}>Share your preference / availability</label>
                  <textarea
                    className="input-text-input"
                    placeholder="e.g. I'm available weekday evenings after 6 PM IST, prefer Thursday or Friday..."
                    value={data.expertNote || ""}
                    onChange={(e) => updateState("expertNote", e.target.value)}
                    style={{ minHeight: '120px', marginBottom: '16px' }}
                  />
                  <p style={{ fontSize: '13px', opacity: 0.7, fontWeight: 500 }}>The expert will review your preference and send you a confirmed slot via email.</p>
                </div>
              )}

              {(data.bookingMode === "self" || isGroupPackage) && (
                <div className="v14-calTimeSplit">
                  <div className="v14-calSide">
                    <div className="v14-section-eyebrow" style={{ marginBottom: '16px' }}>
                      <FiCalendar size={14} style={{ marginRight: '6px', verticalAlign: 'text-bottom' }} />
                      Select Date
                    </div>
                    <MonthGridCalendar
                      slots={data.slots}
                      packageDays={isGroupPackage ? packageDays : []}
                      selectedValue={data.activeIndexData?.value}
                      onSelect={(slotObj) => {
                        const idx = data.slots?.findIndex((s) => s.value === slotObj.value);
                        viewAvailableSlot(idx ?? 0, slotObj, slotObj.available);
                      }}
                    />
                  </div>

                  <div className="v14-timeSide">
                    {data.activeIndexData?.value && (
                      <div className="v14-tzChip">
                        <FiClock size={14} style={{ marginRight: '4px' }} /> {eventData.timeZone ? `Times in ${eventData.timeZone}` : "Times in IST"}
                      </div>
                    )}

                    {!data.activeIndexData?.value ? (
                      <div style={{ padding: '60px 20px', textAlign: 'center', opacity: 0.4, border: '1px solid var(--v14-border)', background: '#fff', borderRadius: '4px' }}>
                        <FiCalendar size={40} style={{ marginBottom: '16px' }} />
                        <p style={{ fontSize: '13px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em' }}>No date selected<br /><span style={{ opacity: 0.7, fontWeight: 500, fontSize: '12px', textTransform: 'none' }}>Pick a date on the left</span></p>
                      </div>
                    ) : (
                      <div className="v14-twoColSlots">
                        {(isGroupPackage ? timeSlots : getAllSlots()).length > 0 ? (
                          (isGroupPackage ? timeSlots : getAllSlots()).map((item, i) => {
                            const fromStr = item.from ?? "";
                            const toStr = item.to ?? "";
                            const fmt = fromStr.includes("AM") || fromStr.includes("PM") ? "hh:mm A" : "HH:mm";
                            const displayFrom = moment(fromStr, fmt).isValid() ? moment(fromStr, fmt).format("h:mm A") : fromStr;
                            const displayTo = moment(toStr, fmt).isValid() ? moment(toStr, fmt).format("h:mm A") : toStr;
                            const isSelected = data.selectedSlot?.from === fromStr && data.selectedSlot?.to === toStr;
                            const isDisabled = item.slotAvailable === false;

                            return (
                              <button
                                type="button"
                                key={i}
                                className={`timeSlotBtn ${isSelected ? 'tsActive' : ''}`}
                                style={{ padding: '14px', fontSize: '13px', cursor: isDisabled ? 'not-allowed' : 'pointer', opacity: isDisabled ? 0.5 : 1 }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (!isDisabled) {
                                    updateState("slotActiveIndex", isGroupPackage ? i : getAllSlots().findIndex(s => s.from === item.from));
                                    updateState("selectedSlot", item);
                                  }
                                }}
                              >
                                {displayFrom} – {displayTo}
                              </button>
                            );
                          })
                        ) : (
                          <p style={{ gridColumn: '1/-1', fontSize: '13px', opacity: 0.7, fontWeight: 700, textTransform: 'uppercase', color: 'var(--v14-green)' }}>No slots available</p>
                        )}
                      </div>
                    )}

                    {!isGroupPackage && data.activeIndexData?.value && (
                      <div style={{ display: 'flex', gap: '16px', padding: '24px', background: '#fff', border: '1px solid var(--v14-border)', marginTop: '24px', borderRadius: '4px' }}>
                        <FiZap size={20} color="var(--v14-green)" style={{ flexShrink: 0 }} />
                        <div>
                          <h6 style={{ fontSize: '14px', fontWeight: 800, marginBottom: '8px', textTransform: 'uppercase', color: 'var(--v14-green)' }}>Instant confirmation</h6>
                          <p style={{ fontSize: '13px', opacity: 0.7, lineHeight: 1.5, fontWeight: 500 }}>Your session will be confirmed immediately after booking.</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div style={{ marginTop: '48px', display: 'flex', justifyContent: 'center' }}>
                <button
                  type="button"
                  className="v14-btn-primary"
                  style={{ width: '100%', maxWidth: '400px', justifyContent: 'center' }}
                  onClick={() => isPreview ? () => {} : confirmDetails()}
                >
                  Continue to Details <FiArrowRight size={18} />
                </button>
              </div>

            </div>
          )}
        </div>
      </div>
    );
  };

  const currentBoxReview = reviews[reviewIndex] || reviews[0];
  const bannerReview = reviews[0];

  return (
    <div className="v14-wrapper">
      <div className="v14-container">

        {/* Navigation */}
        <header className="v14-header">
          <div className="v14-logo-group">
            <span className="v14-logo-circle">
              {businessLogo && businessLogo !== calendar ? (
                <img src={businessLogo} alt="Logo" />
              ) : (
                "RN"
              )}
            </span>
            <span>Hello, Bonjour, こんにちは</span>
          </div>
          <div className="v14-header-tag">
            with {businessName.split(' ')[0]} - Online language club
          </div>
        </header>

        {/* 3-Column Hero Area */}
        <section className="v14-hero">
          <div className="v14-hero-bubble-wrapper">
            <div className="v14-speech-bubble">Hola!</div>
          </div>

          <div className="v14-hero-content">
            {/* NEW UI: eyebrow now driven by sliderTextTwo */}
            <div className="v14-hero-eyebrow">{displayEyebrow}</div>
            <h1 className="v14-hero-title">
              {displayTitle}
            </h1>
            <div className="v14-hero-desc" dangerouslySetInnerHTML={{ __html: eventData.description || "Warm, lively conversation lessons for adults learning Spanish and French for life beyond the textbook." }} />
            {/* FIX 1: scrollIntoView instead of offsetTop-based scrollTo — offsetTop
                is relative to the nearest positioned ancestor, not the page, so any
                positioned ancestor in the tree (e.g. the modal overlay) makes it
                resolve to 0 or the wrong offset. scrollIntoView always targets the
                real element regardless of ancestor positioning. */}
            <button
              type="button"
              className="v14-btn-primary"
              onClick={() =>
                document
                  .querySelector('#services-section')
                  ?.scrollIntoView({ behavior: 'smooth', block: 'start' })
              }
            >
              Join a lesson
            </button>
          </div>

          <div className="v14-hero-visual">
            {businessLogo && businessLogo !== calendar ? (
              <div className="v14-hero-image" style={{ backgroundImage: `url(${businessLogo})` }}></div>
            ) : (
              <div className="v14-hero-image" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=600')` }}></div>
            )}
          </div>
        </section>

        {/* Services Grid (2 Columns, Flush Borders) */}
        <div className="v14-services-wrapper" id="services-section">
          <div className="v14-services-grid">
            {serviceList.map((item, ind) => {
              return (
                <div key={ind} className="v14-service-card">
                  <h3 className="v14-service-name">{item.serviceName}</h3>
                  <div className="v14-service-meta">
                    {item.duration} min · {priceLabel(item)} {item.timeLabel ? `· ${item.timeLabel}` : ''}
                  </div>
                  <div className="v14-service-type">
                    {item.appointmentName?.replace(/_/g, ' ').toUpperCase() || "INDIVIDUAL LESSON"}
                  </div>
                  <p className="v14-service-desc">{item.description}</p>
                  <button type="button" className="v14-btn-outline" onClick={() => handleBookClick(item, ind)}>
                    {item.btnText || "Book this session →"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* Solid Green Testimonial Banner */}
        {reviews.length > 0 && (
          <div className="v14-testimonial-banner">
            <div className="v14-banner-left">
              <div className="v14-banner-quote">
                “{bannerReview?.suggestion && bannerReview.suggestion !== "Not given" ? bannerReview.suggestion : "I stopped translating in my head by week three."}”
              </div>
              <div className="v14-banner-stars">
                {Array.from({ length: Math.round(bannerReview?.satisfaction || 5) }).map((_, i) => (
                  <FaStar key={i} size={14} color="#fff" />
                ))}
              </div>
              <div className="v14-banner-author">
                {bannerReview?.name || "Aditi G."} · {bannerReview?.source || "Google"}
              </div>
            </div>
            <div className="v14-banner-right">
              NEXT CLUB: THURSDAY, 7 PM
            </div>
          </div>
        )}

        {/* Client Notes Box Slider */}
        <section className="v14-notes-section">
          <div className="v14-notes-box">
            <div className="v14-notes-header">
              <div>
                <div className="v14-section-eyebrow">CLIENT NOTES</div>
                <h2 className="v14-notes-title">What clients say about {businessName}</h2>
              </div>
              <div style={{ fontSize: '13px', fontWeight: 600, color: 'var(--v14-green)' }}>★★★★★ · {avgRating}</div>
            </div>

            <div className="v14-notes-content">
              <blockquote>
                ““{currentBoxReview?.suggestion && currentBoxReview.suggestion !== "Not given"
                  ? currentBoxReview.suggestion
                  : "My son now explains his working instead of avoiding the question."}””
              </blockquote>

              <div style={{ fontSize: '13px', marginBottom: '32px', opacity: 0.8, display: 'flex', alignItems: 'center' }}>
                {Array.from({ length: Math.round(currentBoxReview?.satisfaction || 5) }).map((_, i) => (
                  <FaStar key={i} size={12} color="var(--v14-green)" style={{ marginRight: '2px' }} />
                ))}
                &nbsp;· {currentBoxReview?.name || "Meera S."} · {currentBoxReview?.source || "Parent review"}
              </div>

              <div className="v14-notes-controls">
                <div>
                  <button type="button" className="v14-arrow-btn" onClick={handlePrevReview}>←</button>
                  <button type="button" className="v14-arrow-btn" onClick={handleNextReview}>→</button>
                </div>
                <div style={{ fontSize: '12px', opacity: 0.6, letterSpacing: '0.1em', fontWeight: 600 }}>
                  {reviews.length > 0 ? `${reviewIndex + 1} / ${reviews.length}` : "1 / 3"}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Ready-Made Resources Section */}
        {resourceList.length > 0 && (
          <section className="v14-resources-section" id="resources-section">
            <div className="v14-section-eyebrow" style={{ color: 'var(--v14-green)' }}>DIGITAL RESOURCES</div>
            <h2 style={{ fontFamily: 'var(--font-serif)', fontSize: '28px', marginBottom: '32px', color: 'var(--v14-green)' }}>
              Self-guided materials & tools
            </h2>
            <div className="v14-resources-grid">
              {resourceList.map((res, ind) => {
                const isResourceFree = Number(res.amount) === 0;
                const fileCount = res.resourceFiles?.length || 0;

                return (
                  <div key={res.id} className="v14-resource-card" onClick={() => handleResourceCardClick(res)} style={{ cursor: 'pointer' }}>
                    <div style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '8px', fontWeight: 700, color: 'var(--v14-green)' }}>
                      RESOURCE {ind + 1} {fileCount > 0 && `· ${fileCount} FILE${fileCount !== 1 ? 'S' : ''}`}
                    </div>
                    <h3 style={{ fontFamily: 'var(--font-serif)', fontSize: '18px', fontWeight: 600, marginBottom: '8px', color: 'var(--v14-green)' }}>{res.serviceName}</h3>
                    <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '16px' }}>
                      {isResourceFree ? "Free" : `₹${res.amount}`}
                    </div>
                    <p style={{ fontSize: '13px', lineHeight: 1.5, opacity: 0.8, flex: 1, marginBottom: '24px' }}>{res.description}</p>
                    <button
                      type="button"
                      className="v14-btn-outline"
                      style={{ width: 'fit-content' }}
                      onClick={(e) => { e.stopPropagation(); handleResourceCardClick(res); }}
                    >
                      {isResourceFree ? (
                        <>Download <FiDownload size={14} /></>
                      ) : (
                        <>Purchase <FiLock size={12} /></>
                      )}
                    </button>
                  </div>
                );
              })}
            </div>
          </section>
        )}

        {/* About Provider */}
        <section className="v14-about-section">
          <div className="v14-section-eyebrow">MEET YOUR PROVIDER</div>
          <h3 style={{ fontFamily: 'var(--font-serif)', fontSize: '32px', marginBottom: '16px', fontWeight: '600', color: 'var(--v14-dark)' }}>{businessName}</h3>
          <p style={{ fontSize: '14px', maxWidth: '480px', lineHeight: 1.6, opacity: 0.9 }}>
            {userDetails.profession?.professionName || "Ritu makes language learning social, spoken and part of everyday life."}
          </p>

          {eventData.specialisations && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', maxWidth: '500px', marginTop: '32px' }}>
              {eventData.specialisations.split(',').map((spec, i) => (
                <span key={i} style={{ border: '1px solid var(--v14-border)', padding: '6px 12px', fontSize: '11px', borderRadius: '4px', fontWeight: 600, textTransform: 'uppercase', color: 'var(--v14-muted)' }}>{spec.trim()}</span>
              ))}
            </div>
          )}

          <div style={{ marginTop: '64px' }}>
            <svg width="120" height="30" viewBox="0 0 120 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5 5 C10 12 15 20 18 20 C18 10 15 5 12.5 5 Z" fill="#e91e63" />
              <path d="M22 5 C24.5 12 19 20 16 20 C16 10 19 5 22 5 Z" fill="#e91e63" opacity="0.8" />
              <text x="32" y="21" fontFamily="Inter" fontWeight="800" fontSize="18" fill="var(--v14-dark)">Yuukke</text>
            </svg>
          </div>
        </section>

        {/* Render Booking Modal */}
        {renderBookingModal()}
      </div>
    </div>
  );
};

export default ServiceCardThemeV14;